import $foreign from "./foreign.cjs";
var $$char = $foreign.char;
var charAt = $foreign.charAt;
export { $$char as char, charAt };
